import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { Helmet } from 'react-helmet';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { Link } from '@cp/ds/src/components/link';
import { useStaticRouterContext } from '../../shared/context/staticRouterContext/context';

const ExceptionPage: React.FC = () => {
  const staticRouterContext = useStaticRouterContext();

  if (staticRouterContext) {
    staticRouterContext.statusCode = HttpStatusCode.InternalServerError;
  }

  return (
    <div>
      <Helmet>
        <title>Ошибка сервиса</title>
      </Helmet>
      <Container>
        <Stack my={{ xs: 4, md: 18 }}>
          <Typography sx={{ textAlign: 'center', mb: 4 }} variant="h4">
            Кажется, что-то пошло не так...
          </Typography>
          <Typography sx={{ textAlign: 'center' }} variant="body">
            Мы уже работаем над исправлением ошибки
          </Typography>
          <Link external href="/" sx={{ textAlign: 'center' }} target="_self">
            Обновить страницу
          </Link>
        </Stack>
      </Container>
    </div>
  );
};

export default ExceptionPage;
